import React, {useEffect, useMemo, useRef, useState} from 'react';
import './SportsFilterBar.style.scss';
import SportIcon from "../../../SportIcon/SportIcon";
import {Seasons} from "../../../../constants/SportsConst";
import {useIntl} from "react-intl";
import GlobalConst from "../../../../constants/GlobalConst";

const sportsTabs = [
    {labelId: "sportsFilterBar.NHL", sportId: 1, enabled: true},
    {labelId: "sportsFilterBar.NBA", sportId: 2, enabled: true},
    {labelId: "sportsFilterBar.NFL", sportId: 4, enabled: true},
    {labelId: "sportsFilterBar.MLB", sportId: 9, enabled: true},
    {labelId: "sportsFilterBar.GOLF", sportId: 12, enabled: true},
    {labelId: "sportsFilterBar.SOCCER", sportId: 3, enabled: true}];

const SportsFilterBar = ({vm}) => {
    const isMobile = window.innerWidth < 768;
    const intl = useIntl();
    const selectedSportId = vm.filters.sportId;
    const selectedSeasonId = vm.filters.seasonId;
    const isSoccerTabSelected = selectedSportId === 3;
    const tabs = useMemo(() => {
        const availableSportIds = [...new Set(vm.viewData.contests.map(g => g.SportId))];
        let subTabs = null;

        if(isSoccerTabSelected){
            const soccerSeasonIds = [...new Set(vm.viewData.contests.filter(c=>c.SportId === 3).map(c => c.SeasonId))];
            const seasons = soccerSeasonIds.map(seasonId => Seasons.find(s => s.seasonId == seasonId));
            subTabs = seasons.map(season => ({
                label: season.abvr,
                seasonId: season.seasonId,
                sportId: 3,
                enabled: true
            }));

            if (GlobalConst.FEATURES.DOTMX) {
                const MX_LEAGUE_ORDER = ["130979", "130281", "127179", "131609"];
                subTabs.sort((a, b) => {
                    const ai = MX_LEAGUE_ORDER.indexOf(a.seasonId);
                    const bi = MX_LEAGUE_ORDER.indexOf(b.seasonId);
                    return (ai === -1 ? 999 : ai) - (bi === -1 ? 999 : bi);
                });
            }
        }

        return sportsTabs.map(tab => ({
                            ...tab,
                            enabled: availableSportIds.includes(tab.sportId),
                            subTabs
                          }))
                         .sort((tabA, tabB) => {
                             if (GlobalConst.FEATURES.DOTMX) {
                                 if (tabA.sportId === 3) return -1;
                                 if (tabB.sportId === 3) return 1;
                             }
                             if (tabA.enabled === tabB.enabled) return 0;
                             return tabA.enabled ? -1 : 1;
                         });
    }, [vm.viewData.lastUpdate, selectedSportId]);

    const handleTabClick = (sportId)=>{
        const value = sportId === selectedSportId ? null : sportId;
        vm.handleFilterChange("sportId", value);
    };

    const handleSubTabClick = (seasonId) => {
        const value = seasonId === selectedSeasonId ? null : seasonId;
        vm.handleFilterChange("seasonId", value);
    };

    return (
        <div className={`SportsFilterBar`}>
            {selectedSportId
                ? tabs.filter(tab => tab.sportId === selectedSportId).map(tab => {

                    const showSubTabs = tab.subTabs && tab.subTabs.length > 0 && tab.sportId === selectedSportId;

                    return (
                    <><button type="button"
                              key={tab.sportId + (showSubTabs ? `-${selectedSeasonId}` : '')}
                            className={`tab-button selected gold-gradient-border ${showSubTabs ? 'has-sub-tabs' : ''}`}
                            onClick={() => handleTabClick(tab.sportId)}
                            disabled={!tab.enabled}
                    >
                        <SportIcon sportId={tab.sportId} />
                        { (!isMobile || tabs.length <= 3) && <span>{intl.formatMessage({id: tab.labelId})}</span>}
                    </button>
                        {showSubTabs && <div className="sub-tabs">
                            {tab.subTabs?.map(st => (
                                <button
                                    type="button"
                                    key={st.seasonId}
                                    className={`tab-button sub-tab ${selectedSeasonId === st.seasonId ? 'selected' : ''}`}
                                    onClick={() => handleSubTabClick(st.seasonId)}
                                    disabled={!tab.enabled || st.disabled}
                                    aria-pressed={selectedSeasonId === st.seasonId}
                                >
                                    {st.label}
                                </button>
                            ))}
                        </div>}
                    </>
                )})
                : tabs.filter(tab => tab.enabled).map(tab => (
                    <button key={tab.sportId}
                            className={`tab-button unselected`}
                            onClick={() => handleTabClick(tab.sportId)}
                            disabled={!tab.enabled}
                    >
                        <SportIcon sportId={tab.sportId} />
                        <span>{intl.formatMessage({id: tab.labelId})}</span>
                    </button>
                ))
            }
        </div>
    );
};

export default SportsFilterBar;
